
export const endpoint = {
  currentUser: 'user/current',
  options: {
    unit: 'user/current/options/unit',
    language: 'user/current/options/language',
    location: 'user/current/options/location',
    usergroup: 'user/current/options/userGroups'
  },
  changePassword: 'user/current/password'
};
